import { FormattedMessage } from 'react-intl';

import Tire from './tire';
import car from '../assets/Images/car.png';
import { Tire as TireModel } from '../models/tire';
import { TirePosition } from '../models/tire-position.ts';
import {TireConfig} from "../models/report.ts";
import {TireImagePosition} from "../models/enums/tire-image-position.enum.ts";

type CarProps = {
    tires: Partial<TireModel>[];
    config?: TireConfig;
    refDate?: Date | null;
};

const Car = ({tires, config, refDate}: CarProps) => {
    const frontLeft = tires.find(t => t.position === TirePosition.FRONT_LEFT);
    const frontRight = tires.find(t => t.position === TirePosition.FRONT_RIGHT);
    const rearLeft = tires.find(t => t.position === TirePosition.REAR_LEFT);
    const rearRight = tires.find(t => t.position === TirePosition.REAR_RIGHT);

    return (
        <>
            <div className="flex flex-col justify-around w-1/3 gap-6">
                {frontLeft && <Tire tire={frontLeft} config={config} refDate={refDate}/>}
                {rearLeft && <Tire tire={rearLeft} config={config} refDate={refDate}/>}
            </div>
            <div className="flex flex-col items-center justify-between w-1/3">
                <p className="opacity-20 text-2vw tv:text-2vw font-bold text-center uppercase text-darkGrey mt-10">
                    <FormattedMessage id="front" defaultMessage="Front"/>
                </p>
                <img className="w-2/3 tv:w-4/5" src={car} alt="Car"/>
                <p className="opacity-20 text-2vw tv:text-2vw font-bold text-center uppercase text-darkGrey mb-10">
                    <FormattedMessage id="rear" defaultMessage="Rear"/>
                </p>
            </div>
            <div className="flex flex-col justify-around w-1/3 gap-6">
                {frontRight && <Tire tire={frontRight} position={TireImagePosition.LEFT} config={config} refDate={refDate}/>}
                {rearRight && <Tire tire={rearRight} position={TireImagePosition.LEFT} config={config} refDate={refDate}/>}
            </div>
        </>
    );
};

export default Car;
